import React, { useState } from 'react'
import { Region, transformRegionToMap } from 'msp-integrations'
import NewsletterWrapper from '@cms/NewsletterWrapper/NewsletterWrapper'
import Headline from '@atoms/Headline/Headline'

const NewsletterSignup = ({
  data,
  regions,
  custom
}: {
  data: any
  regions: Array<any>
  custom?: any
}) => {
  const [wasNewsletterSent, setWasNewsletterSent] = useState(false)
  const {
    newsLetterSignupImageAlt,
    newsletterSignupColorBackground,
    newsletterSignupHeadline
  } = data || {}

  const descriptionRegion = transformRegionToMap(regions).get(
    'newsletterSignupDescription'
  )

  const backgroundColor =
    newsletterSignupColorBackground === 'black' ? 'bg-black' : 'bg-darkGreen'
  const { content } = custom || {}
  const { newsLetterSignupImage: imgUrl } = content || {}

  return (
    <div className='relative grid max-lg:auto-rows-auto lg:grid-cols-2'>
      <div
        className={`lg:order-0 flex flex-col justify-center px-5 py-8 max-lg:order-2 md:px-12 2xl:px-48 2xl:py-12 ${backgroundColor} text-white`}
      >
        <Headline tag='h2' className='text-white'>
          {newsletterSignupHeadline || ''}
        </Headline>
        {descriptionRegion && !wasNewsletterSent && (
          <Region region={descriptionRegion} subClassName='py-6' />
        )}
        <NewsletterWrapper
          buttonClassname={'bg-transparent'}
          onSuccess={() => setWasNewsletterSent(true)}
          noDescription
          isDarkMode
        />
      </div>
      <div>
        <img
          className={`h-full max-h-[800px] w-full object-cover max-lg:max-h-[430px] max-md:max-h-[375px]`}
          src={imgUrl}
          alt={newsLetterSignupImageAlt}
        />
      </div>
    </div>
  )
}

export default NewsletterSignup
